import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\GetDossierSupplierOrderController::__invoke
* @see app/Http/Controllers/Dossier/GetDossierSupplierOrderController.php
* @route '/api/dossier/{dossier}/supplier-order'
*/
const GetDossierSupplierOrderController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetDossierSupplierOrderController.url(args, options),
    method: 'get',
})

GetDossierSupplierOrderController.definition = {
    methods: ["get","head"],
    url: '/api/dossier/{dossier}/supplier-order',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\GetDossierSupplierOrderController::__invoke
* @see app/Http/Controllers/Dossier/GetDossierSupplierOrderController.php
* @route '/api/dossier/{dossier}/supplier-order'
*/
GetDossierSupplierOrderController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return GetDossierSupplierOrderController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\GetDossierSupplierOrderController::__invoke
* @see app/Http/Controllers/Dossier/GetDossierSupplierOrderController.php
* @route '/api/dossier/{dossier}/supplier-order'
*/
GetDossierSupplierOrderController.get = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetDossierSupplierOrderController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\GetDossierSupplierOrderController::__invoke
* @see app/Http/Controllers/Dossier/GetDossierSupplierOrderController.php
* @route '/api/dossier/{dossier}/supplier-order'
*/
GetDossierSupplierOrderController.head = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetDossierSupplierOrderController.url(args, options),
    method: 'head',
})

export default GetDossierSupplierOrderController